import { gql } from '@apollo/client';

export const DELETE_USER_MUTATION = gql`
	mutation RemoveUser($id: Int!) {
		removeUser(id: $id) {
      id
		}
	}
`;